import { AppMapperError, Mapper } from 'module/Common';
import { MenuItemType } from './item/MenuItemType';
import {
  MenuItem,
  MenuItemSocialLinks,
  MenuItemPageLink,
  MenuItemPostLink,
  MenuItemCategoryLink,
  MenuItemExternalLink,
  MenuItemCategoryLinkMultiple,
  MenuItemNewsletter,
} from './item';

export {
  MenuItem,
  MenuItemSocialLinks,
  MenuItemPageLink,
  MenuItemPostLink,
  MenuItemCategoryLink,
  MenuItemCategoryLinkMultiple,
  MenuItemExternalLink,
  MenuItemNewsletter,
} from './item';
export { MenuItemType } from './item/MenuItemType';

export type Menu = Array<MenuItem>;

export namespace Menu {
  const itemMapper: Mapper<MenuItem> = (input: any, path: Array<string>): MenuItem => {
    const type = Mapper.exec(
      Mapper.mapSchemaPartial({ acf_fc_layout: Mapper.stringEnum<MenuItemType>(MenuItemType) }, v => v.acf_fc_layout),
      input
    );
    switch (type) {
      case MenuItemType.CategoryLink:
        return Mapper.exec(MenuItemCategoryLink.mapper, input, path);
      case MenuItemType.PageLink:
        return Mapper.exec(MenuItemPageLink.mapper, input, path);
      case MenuItemType.PostLink:
        return Mapper.exec(MenuItemPostLink.mapper, input, path);
      case MenuItemType.CategoryLinkMultiple:
        return Mapper.exec(MenuItemCategoryLinkMultiple.mapper, input, path);
      case MenuItemType.ExternalLink:
        return Mapper.exec(MenuItemExternalLink.mapper, input, path);
      case MenuItemType.SocialLinks:
        return Mapper.exec(MenuItemSocialLinks.mapper, input, path);
      case MenuItemType.Newsletter:
        return Mapper.exec(MenuItemNewsletter.mapper, input, path);
      default:
        throw new Error(`Unhandled menu item type ${type}`);
    }
  };

  export const mapper = Mapper.errorWrapper(err => new AppMapperError('Menu', err), Mapper.array(itemMapper));
}



// WEBPACK FOOTER //
// ./src/module/Model/Menu/index.ts